import { useNavigate, useParams } from "react-router-dom";
import { useEditPost } from "../hooks/useEditPost";
import BoardReplyEditRow from "../detail/BoardReplyEditRow";
import { UpdatePostApiProps } from "../../../../types/support/board";
import { useState } from "react";
import { useEditPostReply } from "../hooks/useEditPostReply";
import { FreedomEditor } from "../../../../components/common/FreedomEditor";

export default function BoardDetailInput() {
    const navigate = useNavigate();
    const { id } = useParams();
    const { inputData, setInputData, onChangeInputData, savePost, UploadUI, handleButtonClick, removeFile } = useEditPost();
    const { deletePostReply } = useEditPostReply({ postId: id ?? '' });

    const [editRowKeyArr, setEditRowKeyArr] = useState<string[]>([]);

    const addEditRowKey = (key: string) => {
        if (!editRowKeyArr.includes(key))
            setEditRowKeyArr([...editRowKeyArr, key]);
    }

    const removeEditRowKey = (key: string) => {
        setEditRowKeyArr(editRowKeyArr.filter((item) => item !== key));
    }

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">게시판 등록/수정</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-primary w-100px h-38px"
                            onClick={() => savePost(inputData as UpdatePostApiProps)}>저장
                        </button>
                        <button
                            className="btn btn-outline-secondary w-100px h-38px"
                            onClick={() => inputData.postId ? navigate(`${process.env.PUBLIC_URL}/support/board/detail/${inputData.postId}`, { replace: true })
                                : navigate(-1)}>
                            취소
                        </button>
                    </div>
                </div>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <tbody>
                            <tr>
                                <th style={{ width: "12.5%" }}>제목</th>
                                <td className="p-4px">
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={inputData?.title ?? ''}
                                        name={"title"}
                                        onChange={e => onChangeInputData(e)} />
                                </td>
                            </tr>
                            <tr>
                                <th>작성자/등록일</th>
                                <td>{inputData?.userName} | {inputData?.regAt}</td>
                            </tr>
                            <tr style={{ height: "249px" }}>
                                <th>내용</th>
                                <td style={{ verticalAlign: "top" }}>
                                    <FreedomEditor
                                        setValue={setInputData}
                                        value={inputData?.body ?? ''}
                                        fieldName={'body'} />
                                </td>
                            </tr>
                            <tr>
                                <th>첨부파일</th>
                                <td>
                                    <div className="tbl_files_outer">
                                        {inputData?.fileVOList.length !== 0 && <ul className="list_files">
                                            {inputData?.fileVOList.map((item: any) => <li>
                                                <a href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${item.fileKey}&fileOrgname=${item.fileOrgname}&fileUrl=${item.fileUrl}`)}>
                                                    {item.fileOrgname}
                                                </a>
                                                <button
                                                    className="btn btn-link p-0"
                                                    onClick={() => removeFile(item.fileKey)}>
                                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_deltoken.png"}
                                                        alt="" />
                                                </button>
                                            </li>)}
                                        </ul>}
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={() => handleButtonClick()}>파일 업로드
                                        </button>
                                        <UploadUI />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="content_wrap">
                <h3 className="comment_heading">답변</h3>

                {(inputData?.replyList ?? []).map((item: any) => !editRowKeyArr.includes(item.postReplyId) ?
                    <div className="comment_item">
                        <div className="comment_top">
                            <div className="user_detail">
                                <div>
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_user_comment.png"} alt="" />
                                </div>
                                <div>
                                    {item.userName}<br />
                                    {item.regAt}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-15px">
                                <a className="me-5px" onClick={() => addEditRowKey(item.postReplyId)}><img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_edit_post.png"} alt="" /></a>
                                <a className="" onClick={() => deletePostReply(item.postReplyId)}><img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_delete_post.png"} alt="" /></a>
                            </div>
                        </div>
                        <div className="comment_detail">
                            <div className="message" dangerouslySetInnerHTML={{ __html: item.body }}></div>
                            {item.fileVOList.length > 0 && <div className="btn_list_files">
                                {item.fileVOList.map((file: any) => <>
                                    <button className="btn btn-outline-secondary"
                                        onClick={() => document.getElementById(`file-${file.fileKey}`)?.click()}>
                                        <a id={`file-${file.fileKey}`}
                                            href={encodeURI(`${process.env.REACT_APP_SERVER_URL}api/customer/support/download_support_file?fileKey=${file.fileKey}&fileOrgname=${file.fileOrgname}&fileUrl=${file.fileUrl}`)}></a>
                                        {file.fileOrgname}&nbsp;
                                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_comment_download.png"}
                                            alt="" />
                                    </button>
                                    &nbsp;
                                </>)}
                            </div>}
                        </div>
                    </div> :
                    <BoardReplyEditRow data={item} onCanceled={removeEditRowKey} postId={id ?? ''} />)}
            </div>
        </>
    );
}